import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { FenceSegmentRecord, IFenceSegmentData } from "common/records/Segment";

export const RECEIVE_SEGMENT = "@measurements_segments/RECEIVE_SEGMENT";
export const SET_SEGMENT = "@measurements_segments/SET_SEGMENT";
export const RESET_SEGMENT = "@measurements_segments/RESET_SEGMENT";
export const DELETE_SEGMENT = "@measurements_segments/DELETE_SEGMENT";
export const SET_GATE_COUNT = "@measurements_fences/SET_GATE_COUNT";
export const SET_GATE_LENGTH = "@measurements_fences/SET_GATE_LENGTH";

export const SegmentActions = {
  receiveSegment: (segment: Partial<IFenceSegmentData>) => createAction(RECEIVE_SEGMENT, { segment }),
  setSegment: (segment: FenceSegmentRecord) => createAction(SET_SEGMENT, { segment }),
  resetSegment: (segmentId: number) => createAction(RESET_SEGMENT, { segmentId }),
  deleteSegment: (segmentId: number) => createAction(DELETE_SEGMENT, { segmentId }),
  setGateCount: (segmentId: number, gateCount: number) => createAction(SET_GATE_COUNT, { segmentId, gateCount }),
  setGateLength: (segmentId: number, gateLength: number) => createAction(SET_GATE_LENGTH, { segmentId, gateLength }),
};

export type SegmentActions = ActionsUnion<typeof SegmentActions>;
